import React, { useState, useEffect, Fragment } from 'react';
import AddCircleIcon from "@material-ui/icons/AddCircle";
import {
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';

// Icons
import EditIcon from "@material-ui/icons/Edit";
import HighlightOffOutlinedIcon from "@material-ui/icons/HighlightOffOutlined";
import translation from "../../../i18n/i18.json"
import useStyles from "./ProcurementCategory.css"
import ProcurementAddDialog from "./ProcurementAddDialog";
import AllActions from '../../../actions';
import { MasterDataService } from '../../../services/MasterDataService';
import { ProcurementCategoryObj } from '../../../models/Master/ProcurementCategory';
import {
  InforDisplyaDuration,
  MasterDataConstants,
  DropdownOptions_NonRM_Services_VendorCategory,
  NonRMCategoryManagedBys,
  ServicesCategoryManagedBys
} from "../../../constants/AppConstants";
import { ProcurementCategoryListResponse } from '../../../models/Master/ProcurementCategoryListResponse';
import { ProcurementSubCategory } from '../../../models/Master/ProcurementSubCategory';
import { ProcurementCategoryFilter } from "../../../models/Master/ProcurementCategoryFilter";
import { VendorCategory } from "../../../models/Master/VendorCategory";
import {CategoryManagedBy} from "../../../models/Master/CategoryManagedBy";
import {VendorMasterData} from "../../../services/VendorMasterData";

export default function ProcurementCategory() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const initialState: ProcurementCategoryObj = {
    id: 0,
    name: "",
    vendorCategoryId: 0,
    vendorCategoryName: "",
    isActive: true,
    procurementSubCategories: [],
  };
  const rowsPerPage = MasterDataConstants.TablerowCount;
  const [page, setPage] = React.useState(0);
  const [rowCount, setRowCount] = React.useState(0);
  const [isTableLoading, setIsTableLoading] = React.useState(false);
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);
  const [isDisabledInput, setIsDisabledInput] = useState(false);
  const [selectedData, setSelectedData] = useState<ProcurementCategoryObj>(initialState);
  const [tableRowData, setTableRowData] = useState<ProcurementCategoryObj[]>([]);
  const [filterParams, setFilterParams] = useState<ProcurementCategoryFilter>({
    pageNo: 0,
    pageSize: rowsPerPage,
    isActive: true,
  });
  const [vendorCategoryList, setvendorCategoryList] = useState<VendorCategory[]>([]);
  const nonRMVendorCategoryList = [DropdownOptions_NonRM_Services_VendorCategory.NonRM, DropdownOptions_NonRM_Services_VendorCategory.Services]
  const [categoryManagedByList, setcategoryManagedByList] = useState<CategoryManagedBy[]>([]);
  

  const tableColumnData = [
    { name: translation.master_procurement_vendorcategoryname },
    { name: translation.master_procurement_name },
    { name: translation.master_procurement_procurementsubcategories },
  ];

  const INITIAL_FILTERS = {

  }


  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const compeleteRequest = (success: boolean, message?: string) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(
            message,
            InforDisplyaDuration.common
          )
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(
            message,
            InforDisplyaDuration.common
          )
        );
      }
    }
  };
  const getProcurementCategoryList = () => {
    prepareForRequest();
    MasterDataService.getProcurementCategories(
      filterParams,
      function (responeData: ProcurementCategoryListResponse) {
        setTableRowData(responeData.procurementCategories);
        setRowCount(responeData.recordCount);
        compeleteRequest(true);
        setIsTableLoading(false);
      },
      function (error: Error) {
        setTableRowData([]);
        compeleteRequest(false, translation.master_user_list_error);
        setIsTableLoading(false);
      }
    );
  };
  useEffect(() => {
    if (isTableLoading) {
      getProcurementCategoryList();
      getSpendManagedByList();
    }
  }, [isTableLoading]);

  useEffect(() => {
    setFilterParams((state) => {
      return {
        ...filterParams,
        pageNo: 1,
      };
    });
    setPage(0);
    setIsTableLoading(true);

  }, []);

  const getDisplaySubCategories = (row: ProcurementCategoryObj) => {
    if (row.procurementSubCategories && row.procurementSubCategories.length > 0) {
      let subNames = row.procurementSubCategories.map((sub: ProcurementSubCategory, index) => {
        return sub.name;
      });
      if (subNames && subNames.length > 0) {
        let subCategorystring = subNames.join(", ");
        return subCategorystring;
      }
      return "";
    }
    return "";
  };
  const handleAddTableData = (e: any) => {
    setSelectedData(initialState);
    setIsDisabledInput(false);
    getProcurementMasterDataAdd();
  };
  const handleChangePage = (event: any, newPage: number) => {
    setFilterParams({ ...filterParams, pageNo: newPage + 1 });
    setPage(newPage);
    setIsTableLoading(true);
  };
  const handleUpdateDialogClose = (e: any) => {
    setIsUpdateOpen(false);
  };
  const getProcurementMasterDataAdd = () => {
    prepareForRequest();
    Promise.allSettled([

      MasterDataService.getVendorCategories(
        function (vendorCategoryListAll: Array<VendorCategory>) {
          if (vendorCategoryList.length == 0) {
            vendorCategoryListAll.map((row: VendorCategory) => {

              if (nonRMVendorCategoryList.includes(row.id)) {
                vendorCategoryList.push({ id: row.id, name: row.name });
              }

            })
          }
        },
        function (error: Error) {
          setvendorCategoryList([]);
        }
      )
      
      
    ]).then((values) => {
      compeleteRequest(true);
      setIsUpdateOpen(true);
    });

  };

  const getSpendManagedByList= () =>{
  VendorMasterData.getCategoryManagedBy(
        function (listAll: Array<CategoryManagedBy>) {
                setcategoryManagedByList(listAll);
              },
         function (error: Error) {
          setcategoryManagedByList([]);
        }
      )
  };


  const onEditClick = (listItem: ProcurementCategoryObj) => {
    setSelectedData(listItem);
    setIsDisabledInput(true);
    getProcurementMasterDataAdd();
  };

  const onDeleteClick = (listItem: ProcurementCategoryObj) => {
    dispatch(
      AllActions.alertDialogActions.openAlertDialog(
        translation.master_delete_con_title,
        translation.master_delete_con_msg,
        translation.master_delete_con_yesbtn,
        function () {
          setSelectedData(listItem);
          prepareForRequest();
          MasterDataService.deleteProcurementCategory(
            listItem,
            function (responseData: any) {
              filterParams.pageNo = 1;
              setPage(0);
              setIsTableLoading(true);
              getProcurementCategoryList();
              compeleteRequest(true, translation.master_procurementcategory_dialog_delete_suc);
              dispatch(AllActions.alertDialogActions.closeAlertDialog());
            },
            function (error: Error) {
              compeleteRequest(false, translation.master_user_delete_err);
            }
          );
        },
        translation.master_delete_con_nobtn,
        function () {
          dispatch(AllActions.alertDialogActions.closeAlertDialog());
        }
      )
    );
  };

  const copyProcurementCategory = (obj: ProcurementCategoryObj) => {
    var copyProcurementCategory: ProcurementCategoryObj = {
      id: obj.id,
      name: obj.name,
      vendorCategoryId: obj.vendorCategoryId,
      isActive: obj.isActive,
      vendorCategoryName: obj.vendorCategoryName,
      procurementSubCategories: obj.procurementSubCategories
        ? obj.procurementSubCategories.map((cl) => {
          return {
            id: cl.id,
            name: cl.name,
            isActive: cl.isActive,
            refSpendManagedById:cl.refSpendManagedById,
            categoryManagedbyName: (cl.refSpendManagedById !=null )? categoryManagedByList.filter(row => row.id == cl.refSpendManagedById)[0].name :""
          }
        })
        : []
    };
    return copyProcurementCategory;
  };

  const handleSuccessUpdate = (proc: ProcurementCategoryObj, mode: any) => {
    if (mode == 0) {
      getProcurementCategoryList();
    }
    else {
      setTableRowData(
        tableRowData.map((row: ProcurementCategoryObj) => {
          if (row.id === proc.id) {
            return proc;
          }
          return row;
        })
      );
    }
  };


  return (
    <React.Fragment>
      <Grid
        container
        spacing={2}
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        className={classes.createHeader}
      >
        <span className={classes.createHeaderTxt}>
          {translation.main_menu_procurementcategory_masterdata}
        </span>
      </Grid>
      <Grid
        container
        spacing={2}
        item
        xs={12}
        sm={12}
        md={1}
        lg={1}
        style={{ float: "right" }}
      >
        <div className={classes.addNewBtnWrapper}>
          <Button
            onClick={handleAddTableData}
            style={{ right: "18px", position: "absolute", top: "80px" }}
          >
            <AddCircleIcon></AddCircleIcon>
            {translation.master_table_procumentcategory_addbtntxt}
          </Button>
        </div>
      </Grid>
      <div className={classes.tblOuterBG}>
        <TableContainer className={classes.tblContainer}>
          <Table size="small" stickyHeader aria-label="sticky table">
            <TableHead className={classes.tblHeader}>
              <TableRow>

                {tableColumnData &&
                  tableColumnData.map((column, index) => {
                    return <TableCell>{column.name}</TableCell>;
                  })}
                <TableCell align="center" style={{ width: "165px" }}>
                  {translation.master_table_actions}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={classes.tblBody}>
              {tableRowData &&
                tableRowData.map((row, index) => {
                  return (
                    <TableRow key={row.id}>
                      <TableCell>{row.vendorCategoryName}</TableCell>
                      <TableCell>{row.name}</TableCell>
                      <TableCell>{getDisplaySubCategories(row)}</TableCell>
                      <TableCell align="center">
                        <div className={classes.editBtn}>
                          {<button onClick={(e) => onEditClick(row)}>
                            <EditIcon></EditIcon>
                            <span className={classes.editBtnTxt}>
                              {translation.master_table_editbtntxt}
                            </span>
                          </button>}
                        </div>
                        <div className={classes.rejectBtn}>
                          {<button
                            disabled={!row.isActive}
                            onClick={(e) => onDeleteClick(row)}
                          >
                            <HighlightOffOutlinedIcon></HighlightOffOutlinedIcon>
                            <span className={classes.rejectBtnTxt}>
                              {translation.master_table_deletebtntxt}
                            </span>
                          </button>}
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={rowCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
        ></TablePagination>
      </div>
      <div>
        <ProcurementAddDialog
          open={isUpdateOpen}
          dataObj={copyProcurementCategory(selectedData)}
          vendorCategoryList={vendorCategoryList}
          setDataObj={setSelectedData}
          handleClose={handleUpdateDialogClose}
          successUpdate={handleSuccessUpdate}
          isDisabledVendorCategory={isDisabledInput}
          categoryManagedByList={categoryManagedByList}
        ></ProcurementAddDialog>
      </div>

    </React.Fragment>
  )
}